<template>
  <a-modal
    width="1200px"
    :title="currentItem.name"
    v-model:visible="visible"
    :footer="false"
  >
  <div class="dataset-detail">
    <!--<div class="detail-page-title">
      {{ info.name }}
      <a-button type="primary">返回</a-button>
    </div>-->
    <a-tabs @change="callback">
      <a-tab-pane key="1" tab="任务信息">
        <div class="paragraph-title">
          基本信息
        </div>
        <div class="info-wrap">
          <div class="info-item">
            <div class="label">任务ID：</div>
            <div class="value">{{ currentItem.id }}</div>
          </div>
          <div class="info-item">
            <div class="label">名称：</div>
            <div class="value">{{ currentItem.name }}</div>
          </div>
          <div class="info-item">
            <div class="label">任务类型：</div>
            <div class="value">{{ getTaskName(currentItem.taskTypeId) }}</div>
          </div>
          <div class="info-item">
            <div class="label">说明：</div>
            <div class="value">{{ currentItem.description?currentItem.description:'--' }}</div>
          </div>
          <div class="info-item">
            <div class="label">发布人：</div>
            <div class="value">{{ getUserName(currentItem.createUserId) }}</div>
          </div>
          <div class="info-item">
            <div class="label">任务量：</div>
            <div class="value">{{ taskNumber }}</div>
          </div>
          <div class="info-item">
            <div class="label">创建时间：</div>
            <div class="value">{{ getDateTime(currentItem.createTime) }}</div>
          </div>
          <div class="info-item">
            <div class="label">要求完成时间：</div>
            <div class="value">{{ getDateTime(currentItem.planFinishTime) }}</div>
          </div>
        </div>
        <div class="paragraph-title">
          标注信息
        </div>
        <div class="info-wrap">
          <div class="info-item">
            <div class="label">状态：</div>
            <div class="value">{{ getSubStateName(currentItem.state) }}</div>
          </div>
         <!-- <div class="info-item">
            <div class="label">智能标注：</div>
            <div class="value">{{ currentItem.smart }}</div>
          </div>-->
          <div class="info-item">
            <div class="label">标注进度：</div>
            <div class="value">{{ currentItem.progress?currentItem.progress:'--' }}</div>
          </div>
          <div class="info-item">
            <div class="label">标注公司：</div>
            <div class="value">{{ currentItem.excuteCompanyId?getCompanyName(currentItem.excuteCompanyId):'--' }}</div>
          </div>
          <div class="info-item">
            <div class="label">标注员：</div>
            <div class="value">{{ currentItem.excuteUserId?getUserName(currentItem.excuteUserId):'--' }}</div>
          </div>
        </div>
      </a-tab-pane>
      <a-tab-pane key="2" tab="标注数据" forceRender>
        <PicList ref="picList"
                 :dataset-id="currentItem.datasetId"
                 @settotal="setTotalCount"></PicList>
      </a-tab-pane>
    </a-tabs>
<!--    <PicDialog ref="picDialog"></PicDialog>-->
  </div>
  </a-modal>
</template>
<script>
// import PicDialog from '../PicDialog'
import PicList from '../../DataPreparation/DataSet/PicList'
import { getDateTime, getTaskName, getTeamName, getSubStateName, getUserName, getCompanyName } from '@/filters'
export default {
  props: {
    currentItem: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    // PicDialog
    PicList
  },
  data () {
    return {
      visible: false,
      info: {
        list1: [],
        list2: []
      },
      page: {
        pageNum: 1,
        pageSize: 10
      },
      taskNumber: '--'
      // picList: []
    }
  },
  /*  created () {
    const id = this.$route.params && this.$route.params.id ? this.$route.params.id : 1113
    this.getInfo(id)
  }, */
  methods: {
    getDateTime,
    getTaskName,
    getTeamName,
    getSubStateName,
    getUserName,
    getCompanyName,
    callback (key) {
      console.log(key)
    },
    open () {
      this.visible = true
      // this.picList = []
      this.$nextTick(() => {
        this.$refs.picList.reset()
      })
    },
    /*  getInfo (id) {
      console.log(id)
      this.info = {
        id: id,
        name: '任务1',
        type: '目标检测',
        description: '说明内容',
        creator: 'name1',
        time: '2020-10-10 15:43:18',
        demandTime: '2020-10-20 15:43:18',
        total: 881,
        state: '已标注',
        smart: '启用',
        progress: '100/240',
        company: '公司1',
        people: '标注员1',
        list1: [
          { name: '标注员1', value: 112 },
          { name: '标注员2', value: 112 },
          { name: '标注员3', value: 112 },
          { name: '标注员4', value: 112 }
        ],
        list2: [
          { name: '审核员1', value: 112 },
          { name: '审核员2', value: 112 }
        ]
      }
    }, */
    openPicDialog () {
      this.$refs.picDialog.open()
    },
    setTotalCount (e) {
      console.log('总量', e)
      this.taskNumber = e
    }
  }
}
</script>
<style lang="less">
.dataset-detail {
  .info-wrap {
    display: flex; flex-wrap: wrap;
    .info-item {
      width: 25%;
      padding: 20px; box-sizing: border-box;
      display: flex;
    }
    .custom-table {
      width: 50%;
      padding: 20px; box-sizing: border-box;
      .table-row {
        display: flex;
      }
    }
  }
  .pic-wrap {
    display: flex; flex-wrap: wrap;
    .pic-item {
      padding: 10px; box-sizing: border-box;
      width: 20%; text-align: center;
      img {
        width: 100%; height: 120px;
      }
    }
  }
}
</style>
